module.exports = __webpack_public_path__ + "static/img/cha.48b9719.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha.png
// module id = sCEu
// module chunks = 1